import React from 'react';
import { Text } from '@mantine/core';
import { useServiceWorkerVersion } from '../hooks/useServiceWorkerVersion';

export const VersionDisplay: React.FC = () => {
  const version = useServiceWorkerVersion();

  if (!version) return null;

  // Extract just the version part from the full version string
  // Format: '2025-10-13-v205352' -> 'v205352' or just show the date part
  const displayVersion = version.includes('-v') 
    ? version.split('-v')[1] 
    : version.split('-').slice(-1)[0];

  return (
    <div style={{ padding: '8px 16px', borderTop: '1px solid var(--app-border)' }}>
      <Text 
        size="xs" 
        c="var(--app-text-muted)" 
        style={{ 
          textAlign: 'center',
          opacity: 0.6,
          fontSize: '10px',
          fontFamily: 'monospace'
        }}
      >
        v{displayVersion}
      </Text>
    </div>
  );
};